import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

/**
 * The white panel every section on the funds page sits in.
 *
 * Editorial chrome: 10px radius, 1px #DFE4EC border, the HTML's light shadow.
 * Gold is never used on the panel itself — only on accents inside.
 */

export const CARD_SHADOW = '0 1px 2px rgba(27,36,54,0.04), 0 4px 14px rgba(27,36,54,0.06)';
export const CARD_SHADOW_LIFTED = CARD_SHADOW;
const PANEL_BORDER = '#DFE4EC';

export function Card({
  children,
  className,
  lifted: _lifted = false,
}: {
  children: ReactNode;
  className?: string;
  lifted?: boolean;
}) {
  return (
    <section
      className={cn('bg-white overflow-hidden', className)}
      style={{
        borderRadius: 10,
        border: `1px solid ${PANEL_BORDER}`,
        boxShadow: CARD_SHADOW,
      }}
    >
      {children}
    </section>
  );
}

export function CardHeader({
  title,
  subtitle,
  right,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'px-7 pt-6 pb-3 border-b flex items-start justify-between gap-3',
        className,
      )}
      style={{ borderColor: PANEL_BORDER }}
    >
      <div className="min-w-0">
        <h3
          className="text-sm font-semibold"
          style={{ fontFamily: 'var(--font-display)', color: '#1B2436' }}
        >
          {title}
        </h3>
        {subtitle ? (
          <p className="text-xs mt-0.5" style={{ color: '#8A93A6' }}>
            {subtitle}
          </p>
        ) : null}
      </div>
      {right ? <div className="shrink-0">{right}</div> : null}
    </div>
  );
}

export function CardFootnote({ children }: { children: ReactNode }) {
  return (
    <div className="px-7 py-3 border-t" style={{ background: '#FAFBFD', borderColor: PANEL_BORDER }}>
      <p className="text-[11px] leading-relaxed" style={{ color: '#8A93A6' }}>
        {children}
      </p>
    </div>
  );
}
